import "./LocationsOverview.scss";

export default {
  name: "LocationsOverview",
  components: {},
  data() {
    return {
      statisticData: {},
      lastNews: [],
      ignoreUser: false,
      statistic: {},
      config: {}
    };
  },
  async mounted() {
    await this.$store.dispatch("getCurrentUser");
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },

    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
};
